module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_oslo_viken_pos.88944fde.png";